import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/reporting/process/list_processes/${customer_id}/agro_exporter/${agro_exporter_id}`
    );
  },
  fetchAgroExporterProcess(
    customer_id,
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `customer/reporting/process/reports/${customer_id}/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  },
  fetchCustomerReport(
    customer_id,
    agro_exporter_id,
    agro_exporter_process_id,
    customer_report_id
  ) {
    return RequesterV1.get(
      `customer/reporting/process/reports/${customer_id}/${agro_exporter_id}/${agro_exporter_process_id}/report_process/${customer_report_id}`
    );
  }
};
